<template>
  <v-container fluid class="inventory-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex flex-start justify-md-start overflow-auto">
              <v-btn @click="addInventoryDialog" color="success" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn @click="runInventoryDialog" color="success" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Run
              </v-btn>

              <v-btn @click="isFindInventory=true" color="success" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" to="/financereport/list">
                <v-icon class="mr-2">mdi-check</v-icon>
                Done
              </v-btn>
              <v-btn 
                color="primary" 
                class="button-shadow mr-2"
                @click="printItem"
                v-show="data_inventory.length>0"
              >
                <v-icon class="mr-2">mdi-printer</v-icon>
                Print
              </v-btn>
              <v-btn color="secondaryConst white--text" class="button-shadow mr-2" @click="deleteInventoryDialog">
                <v-icon class="mr-2">mdi-delete-forever</v-icon>
                Delete
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="csv"
                :name="getFileName()"
              >
                <v-btn 
                  v-show="data_inventory.length>0"
                  color="default" 
                  class="button-shadow mb-2 mr-0 mr-sm-2"
                >
                  <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                  Save
                </v-btn>
              </download-excel>
              <v-btn to="/inventoryjournal/list" color="default" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                Journals
              </v-btn>
              <v-btn to="/inventorycount/list" color="default" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                Counts
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              show-select
              sort-desc
              item-key="_id"
              v-model="data_selected"
              loading-text="Loading... Please wait"
              class="inventorys-table"
              sort-by="locationname"
              :loading="isReceiving || isDeleting"
              :footer-props="footer"
              :headers="header_list"
              :items="data_inventory"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteItem"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Item?
                    </v-card-title>
                    <v-card-text>
                      {{ delete_item.itemname }} - Qty {{ delete_item.itemqty }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteItem = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(delete_item)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.userid="{ item }">
                <div v-if="item.userid!=undefined">
                  <p class="two-line">
                    <v-avatar v-if="users.length>0 && users.find(user=>user._id == item.userid)['userimage']!==''" size="40">
                      <img v-bind:src="users.find(user=>user._id == item.userid)['userimage']" alt="">
                    </v-avatar>
                    <v-avatar
                      v-else
                      color="warning"
                      size="40">
                      <span class="white--text headline">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'][0].toUpperCase() : '' }}</span>
                    </v-avatar>
                  </p>
                  <p class="two-line">
                    <span style="margin-left:5px">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'] : '' }} </span>
                  </p>
                </div>
              </template>
              <template v-slot:item.itemimage="{ item }">
                    <v-img
                    v-if="item.itemimage" 
                    v-bind:src="item.itemimage"
                    max-height="70"
                    max-width="70"
                  ></v-img>
              </template>
              <template v-slot:item.inventorynum="{ item }">
                <p class="two-line">{{ item.inventorytype  }}</p>
                <p class="two-line">{{ item.inventorynum  }}</p>
                <p v-if="item.inventorydate!=undefined" class="two-line">{{ new Date(item.inventorydate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.itemquantity="{ item }">
                <p class="two-line">{{ item.itemquantity!=null ? item.itemquantity.toFixed(2): 0  }}</p>
              </template>
              <template v-slot:item.itemcost="{ item }">
                <p class="two-line">{{ item.itemcost!=null ? item.itemcost.toFixed(2): 0  }}</p>
              </template>
              <template v-slot:item.inventorystatus="{ item }">
                <v-chip
                  v-if="item.inventorystatus!=undefined"
                  :color="item.inventorystatus=='Completed' ? 'successConst white--text' : item.inventorystatus=='Partial' ? 'warning white--text' : 'secondaryConst white--text'" small>
                  {{ item.inventorystatus }}
                </v-chip>
              </template>
              <template v-slot:item.inventorydate="{ item }">
                {{ new Date(item.inventorydate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <div v-if="item._id!=undefined">
                  <v-btn icon color="primary" @click="deleteItemDialog(item)">
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="isAddInventory"
        persistent
        width="400px"
        max-width="400px"
        >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Inventory</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="12">
                  <v-menu
                    ref="menu_inventorydate"
                    v-model="menu_inventorydate"
                    :close-on-content-click="false"
                    :return-value.sync="add_inventory.inventorydate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="add_inventory.inventorydate"
                        label="Inventory Date"
                        v-bind="attrs"
                        v-bind:value="add_inventory.inventorydate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please choose the inventory date"
                        >
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="add_inventory.inventorydate"
                      no-title
                      scrollable
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu_inventorydate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_inventorydate.save(add_inventory.inventorydate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
                </v-col>
              </v-row>
            </v-container>
            </v-card-text>  
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isAddInventory = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="insertInventory"
              >
                Save
              </v-btn>
            </v-card-actions>
          
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isRunInventory"
        persistent
        width="400px"
        max-width="400px"
        >
        <v-card>
          <v-card-title>
            <span class="text-h5">Run Inventory</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="12">
                  <v-menu
                    ref="menu_inventorystartdate"
                    v-model="menu_inventorystartdate"
                    :close-on-content-click="false"
                    :return-value.sync="run_inventory.inventorystartdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="run_inventory.inventorystartdate"
                        label="Start Date"
                        v-bind="attrs"
                        v-bind:value="run_inventory.inventorystartdate"
                        v-on="on"
                        single-line 
                        persistent-hint
                        hint="Start date"
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="run_inventory.inventorystartdate"
                      no-title
                      scrollable
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu_inventorystartdate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_inventorystartdate.save(run_inventory.inventorystartdate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
                </v-col>
                <v-col cols="12" md="12">
                  <v-menu
                    ref="menu_inventoryenddate"
                    v-model="menu_inventoryenddate"
                    :close-on-content-click="false"
                    :return-value.sync="run_inventory.inventoryenddate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="run_inventory.inventoryenddate"
                        label="End Date"
                        v-bind="attrs"
                        v-bind:value="run_inventory.inventoryenddate"
                        v-on="on"
                        single-line 
                        persistent-hint
                        hint="End date"
                        >
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="run_inventory.inventoryenddate"
                      no-title
                      scrollable
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu_inventoryenddate = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu_inventoryenddate.save(run_inventory.inventoryenddate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
                </v-col>
              </v-row>
            </v-container>
            </v-card-text>  
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isRunInventory = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="runInventory"
              >
                Save
              </v-btn>
            </v-card-actions>
          
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isFindInventory"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Find Inventory</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <v-select
                    :items="locations.filter(x=>x.locationstatus=='Active').map(x => {
                              return {text: x.locationname, value: x._id};
                            })"
                    v-model="find_query.locationid"
                    label="Location"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-menu
                    ref="menu_inventoryfinddate"
                    v-model="menu_inventoryfinddate"
                    :close-on-content-click="false"
                    :return-value.sync="find_query.enddate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        v-model="find_query.enddate"
                        label="Inventory Date"
                        v-bind="attrs"
                        v-bind:value="find_query.enddate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Inventory date"
                        >
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="find_query.enddate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_inventoryfinddate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_inventoryfinddate.save(find_query.enddate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isFindInventory = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="resetQuery"
            >
              Reset
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findInventory"
            >
              Find
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isDeleteInventory"
        width="500"
      >
        <v-card>
          <v-card-title>
            Delete this Inventory?
          </v-card-title>
          <v-card-text>
            {{ new Date(delete_inventory.inventorydate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="isDeleteInventory = false">Cancel</v-btn>
          <v-btn color="secondary" class="button-shadow" @click="deleteInventory(delete_inventory)">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'
import { formatStdDate } from '@/mixins/date';

export default {
  name: 'InventoryList',
  data() {
    return {
      config,
      isFindInventory: false,
      isAddInventory: false,
      isRunInventory: false,
      isDeleteInventory: false,
      isDeleteItem: false,
      menu_inventoryfinddate: null,
      menu_inventorydate: null,
      menu_inventorystartdate: null,
      menu_inventoryenddate: null,
      
      itemPerPage: 500,
      delete_inventory: {},
      delete_item: {},
      add_inventory: {},
      run_inventory: {},
      find_query: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      header_list: [
        { text: 'Image', value: 'itemimage', sortable: false, width: '8%', ignore: true },
        { text: 'Inventory Date', value: 'inventorydate', width: '12%', format: 'date', ignore: true},
        { text: 'Location', value: 'locationname', width: '20%' },
        { text: 'Item', value: 'itemname'},
        { text: 'Cost', value: 'itemcost', width: '10%', format: 'decimal'},
        { text: 'Quantity', value: 'itemquantity', width: '10%', format: 'decimal'},
        { text: 'Actions', value: 'actions', sortable: false, width: '5%' },
      ],
      data_inventory: [],
      data_selected: [],
      inventorydate: new Date(),
      report_name: 'Inventory Report',
    }
  },
  computed: {
    ...mapState('Inventory', ['inventory', 'isReceiving', 'isDeleting']),
    ...mapState('Location', ['locations']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('Inventory', ["getInventoryRequest", "findInventoryRequest", "insertInventoryRequest", "runInventoryRequest", "deleteInventoryRequest", "deleteIVTTransactionRequest"]),
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    printItem() {
      let report = {companyid: this.inventory.companyid, report_date: this.inventorydate, report_name: this.report_name};
      console.log(report)
      this.$router.push({ name: 'PrintReport', params: {report: report, data: this.data_inventory, header: this.header_list} });
    },
    getJson(){
      if(this.data_inventory.length==0) return[];
      let json = this.data_inventory.map(trans=>{return {
        inventory_date: new Date(trans.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }),
        location: trans.locationname,
        item: trans.itemname,
        quantity: trans.itemquantity.toFixed(2),
        cost: trans.itemcost.toFixed(2),
        value: (trans.itemcost * trans.itemquantity).toFixed(2),
      }});
      return json;
    },
    getFileName(){
      var d = this.inventorydate;
      var name = 'inventory-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.csv';
    },
    editItem(item) {
      this.$router.push({ name: 'InventoryEdit', params: item });
    },
    viewItem(item) {
      this.$router.push({ name: 'InventoryView', params: item });
    },
    addInventoryDialog() {
      if(this.add_inventory.inventorydate==null){
        let date = formatStdDate(new Date());
        this.add_inventory = {inventorydate: date};
      }
      this.isAddInventory = true;
    },
    runInventoryDialog() {
      let date = formatStdDate(new Date());
      this.run_inventory = {inventorystartdate: date, inventoryenddate: date,};
      this.isRunInventory = true;
    },
    async insertInventory(){
      this.isAddInventory = false;
      let result = await this.insertInventoryRequest(this.add_inventory);
      this.data_inventory = Object.assign([], result.transactions);
      this.data_inventory.sort((a,b) =>{
        if (b.locationcode > a.locationcode) return -1;
        if (a.locationcode < b.locationcode) return 1;
        return 0;
      });  
    },
    async runInventory(){
      this.isRunInventory = false;
      let result = await this.runInventoryRequest(this.run_inventory);
      this.data_inventory = Object.assign([], result.transactions);
      this.data_inventory.sort((a,b) =>{
        if (b.locationcode > a.locationcode) return -1;
        if (a.locationcode < b.locationcode) return 1;
        return 0;
      });  
    },
    async findInventory(){
      this.isFindInventory = false;
      if(Object.keys(this.find_query).length==0){
        await this.getInventoryRequest();
        this.inventorydate = new Date(this.inventory.inventorydate);
        this.data_inventory = Object.assign([], this.inventory.transactions);
        this.data_inventory.sort((a,b) =>{
          if (b.locationcode > a.locationcode) return -1;
          if (a.locationcode < b.locationcode) return 1;
          return 0;
        });
      }
      else{
        let result = await this.findInventoryRequest(this.find_query);
        this.inventorydate = new Date(this.inventory.inventorydate);
        this.data_inventory = Object.assign([], result.transactions);
        this.data_inventory.sort((a,b) =>{
          if (b.locationcode > a.locationcode) return -1;
          if (a.locationcode < b.locationcode) return 1;
          return 0;
        });
      }
    },
    async resetQuery(){
      this.find_query = {};
    },
    async deleteInventory(item) {
      await this.deleteInventoryRequest({_id: item._id});
      await this.getInventoryRequest();
      this.data_inventory = Object.assign([], this.inventory.transactions);
      this.isDeleteInventory = false;
    },
    deleteInventoryDialog() {
      this.isDeleteInventory = true;
      this.delete_inventory = { _id: this.inventory._id, inventorydate: this.inventory.inventorydate }
    },
    deleteItemDialog(item) {
      this.isDeleteItem = true;
      this.delete_item = { _id: item._id, itemname: item.itemname, itemqty: item.itemqty };
    },
    async deleteItem(item) {
      let result = await this.deleteIVTTransactionRequest(item);
      let index = this.data_inventory.findIndex(i=>i._id==result._id);
      this.data_inventory.splice(index, 1);
      this.isDeleteItem = false;
    },
  },
  async created () {
    if(Object.keys(this.inventory).length==0) await this.getInventoryRequest();
    this.inventorydate = new Date(this.inventory.inventorydate);
    this.data_inventory = Object.assign([], this.inventory.transactions);
    this.data_inventory.sort((a,b) =>{
          if (b.locationcode > a.locationcode) return -1;
          if (a.locationcode < b.locationcode) return 1;
          return 0;
    });

    if(this.locations.length==0) await this.getLocationsRequest();

  },
}
</script>

<style src="./List.scss" lang="scss"></style>
